import { embedFilter } from '../sharedFilters'

const DATASET_KEY = 'security_managment_ore'

export default {
  key: 'security_managment_ore',
  label: 'GSMS - ORE',
  timeColumn: 'security_managment_ore.ore_date',
  permission: { action: 'reporting', subject: 'Widget' },

  tables: {
    security_managment_ore: ["id", "ore_id", "ore_date", "ore_owner", "ore_status", "title", "type", "tabletop_or_full_scale", "brief_description", "exercise_parameters", "main_content", "actual_results", "is_adhoc", "created_by", "created_on", "last_updated_by", "last_updated_on", "created_at", "updated_at"],
  },

  views: [
    { value: 'bar', label: 'Barras' },
    { value: 'dona', label: 'Dona' },
    { value: 'ring', label: 'Pastel' },
    { value: 'dataframe', label: 'Lista', adminOnly: true },
    { value: 'timeseries', label: 'Tendencia' },
    { value: 'json', label: 'JSON', adminOnly: true },
  ],

  csvConfig: {
    withTables: 'security_managment_ore',
    columns: '',
    qualifiedColumns: true,
  },

  viewDefaults: {
    csv: { limit: -1 },
    dataframe: { limit: -1 },
    json: { limit: -1 },
    bar: { stack: 'group' },
  },

  fields: [
    { key: 'security_managment_ore.ore_status', label: 'Estatus' },
    { key: 'security_managment_ore.title', label: 'Titulo' },
    { key: 'security_managment_ore.ore_id', label: 'ID ORE' },
    { key: 'security_managment_ore.type', label: 'Tipo' },
    { key: 'security_managment_ore.tabletop_or_full_scale', label: 'Escala' },
    { key: 'security_managment_ore.ore_date', label: 'Fecha', defaultParams: { freq: '1mo' } },
  ],

  filters: [
    embedFilter(DATASET_KEY, 'security_managment_ore.ore_status', 'Estatus', 'status'),
    embedFilter(DATASET_KEY, 'security_managment_ore.title', 'Titulo', 'name'),
    embedFilter(DATASET_KEY, 'security_managment_ore.ore_id', 'ID ORE', 'reference'),
    embedFilter(DATASET_KEY, 'security_managment_ore.type', 'Tipo', 'type'),
    embedFilter(DATASET_KEY, 'security_managment_ore.tabletop_or_full_scale', 'Escala', 'level'),
  ],

    dateGrouping: {
    column: 'security_managment_ore.ore_date',
    presets: [
      { value: '1d', label: 'Dia' },
      { value: '1W', label: 'Semana' },
      { value: '1M', label: 'Mes' },
      { value: '1Y', label: 'Anio' },
    ],
  },
}
